import CompanionMaterialItem from '@/models/CompanionMaterialItem';
import CompanionMaterialItemConverterFactory from './CompanionMaterialItemConverterFactory';

class CompanionMaterialItemConverter {
  build(companionMaterialItem: CompanionMaterialItem): Map<string, unknown> {
    const map: Map<string, unknown> | undefined =
      CompanionMaterialItemConverterFactory.createCompanionMaterialConversionHandler(
        companionMaterialItem.name
      ).execute(companionMaterialItem);
    return map ? map : new Map<string, unknown>();
  }
}

export default CompanionMaterialItemConverter;
